// branch events
import showWorkingHoursEditorEvent from '../../../branch/events/showWorkingHoursEditor.event.branch';

// dealership containers
import DealershipGeneralInfoStepContainer from '../DealershipGeneralInfoStepContainer/DealershipGeneralInfoStepContainer';
import DealershipSelectStepContainer from '../DealershipSelectStepContainer/DealershipSelectStepContainer';
import DealershipUpdateStepContainer from '../DealershipUpdateStepContainer/DealershipUpdateStepContainer';

// dealership events
import showDealershipEditorEvent from '../../events/showEditor.event.dealership';

// dealership permissions
import canEditDealershipNamePermission from '../../permissions/canEditName.permission.dealership';

// components
import Flow from '@drivesally/sally-ui/lib/components/Flow/Flow';

// event HOCs
import subscriptionHOC from '@drivesally/sally-fw/lib/event/hoc/subscription.hoc.event';

// lib
import getTimeZoneFromBranch from '../../../libs/getTimeZoneFromBranch';

// local constants
import DEFAULT_STATE from './constants/defaultState.constant';

// notify
import notify from '@drivesally/sally-ui/lib/libs/notify';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Component} from 'react';

class DealershipEditorContainer extends Component {
  static propTypes = {
    dealerships: PropTypes.array,
    subscribe: PropTypes.func,
  };

  state = {...DEFAULT_STATE};

  componentDidMount() {
    this.props.subscribe(showDealershipEditorEvent.subscribe(this.show));
  }

  show = () => {
    const {minimized} = this.state;
    this.setState(
      minimized
        ? {visible: true, minimized: false}
        : {...DEFAULT_STATE, visible: true}
    );
  };

  close = (ignoreDisabled = false) => {
    const {visible, disabled, done} = this.state;
    if (!visible || (disabled && !ignoreDisabled)) return;

    const state = {visible: false, minimized: false};

    if (!done) return this.setState(state);

    notify({
      id: 'closeDealershipCreationModal',
      title: 'Warning',
      icon: undefined,
      content:
        'Are you sure you want to close this window? All progress will be lost.',
      primary: {
        label: 'Cancel',
        onClick: () => null,
      },
      secondary: {
        label: 'Close',
        onClick: () => this.setState(state),
      },
    });
  };

  finish = () => {
    this.setState({visible: false, minimized: false});
  };

  minimize = (ignoreDisabled = false) => {
    const {visible, disabled} = this.state;
    if (!visible || (disabled && !ignoreDisabled)) return;
    this.setState({visible: false, minimized: true});
  };

  onStep = (step, ignoreCheck = false) => {
    const {disabled, done, step: currentStep} = this.state;
    const goingBack = step < currentStep;
    if (!ignoreCheck && disabled) return;
    const newDone = step - 1 > done ? step - 1 : done;
    this.setState({step, done: newDone, goingBack});
  };

  onStepReset = (step) => () => this.setState({step, done: step - 1});

  onStepComplete = (step) => (data = {}) => {
    // const {disabled} = this.state;
    // if (disabled) return;
    this.setState(data);
    this.onStep(step, true);
  };

  disable = (disabled) => this.setState({disabled});

  flows = () => [
    {title: 'Select Dealership'},
    {title: 'General Info'},
    {title: 'Save'},
  ];

  content = (Content) => {
    const {
      visible,
      goingBack,
      dealership,
      originalDealership,
      step,
      done,
    } = this.state;

    const props = {
      dealership,
      Container: Content,
      done,
      goingBack,
      onClose: this.close,
      onDisabled: this.disable,
      onFinish: this.finish,
      originalDealership,
      visible,
    };

    switch (step) {
      case 1:
        return (
          <DealershipSelectStepContainer
            onNext={this.onStepComplete(2)}
            {...props}
          />
        );
      case 2:
        return (
          <DealershipGeneralInfoStepContainer
            canEditName={canEditDealershipNamePermission()}
            onBack={this.onStepComplete(1)}
            onNext={this.onStepComplete(3)}
            {...props}
          />
        );
      case 3:
        return (
          <DealershipUpdateStepContainer
            onBack={this.onStepComplete(2)}
            {...props}
          />
        );
      default:
        return <Content>You even know what you're doing here?</Content>;
    }
  };

  headerActions = () => {
    const {dealership, done} = this.state;
    return [
      !!done && {
        icon: 'minus',
        tooltip: 'Minimize',
        onClick: this.minimize,
      },
      !!dealership && {
        icon: 'calendar',
        tooltip: 'Operating Hours Editor',
        onClick: this.openWorkingHourEditor,
      },
    ].filter((action) => !!action);
  };

  openWorkingHourEditor = () => {
    const {dealership} = this.state;
    showWorkingHoursEditorEvent.publish({
      object: {...dealership},
      objectType: 'dealership',
      timeZone: getTimeZoneFromBranch({branch: dealership.sally_branch}),
    });
    this.setState({visible: false, minimized: false});
  };

  render() {
    const {visible, step, done, hide, dealership} = this.state;
    const flows = this.flows();
    const flow = flows[step - 1];
    return (
      <Flow
        flows={flows}
        title={
          !!dealership?.name ? `Edit ${dealership.name}` : 'Edit Dealership'
        }
        subtitle={flow.title}
        visible={visible && !hide}
        onClose={this.close}
        step={step}
        done={done}
        size={flow.size || 'medium'}
        onStep={() => {}}
        headerActions={this.headerActions()}
      >
        {this.content}
      </Flow>
    );
  }
}

export default subscriptionHOC(DealershipEditorContainer);
